var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Order Fulfilment'}}),_c('orders-schedule-meal',{attrs:{"allow-marking":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }